import "./TabBar.css";

interface Tab {
  id: number;
  name: string;
  color?: string | null;
}

interface TabBarProps {
  tabs: Tab[];
  activeTabId: number | null;
  onTabClick: (id: number) => void;
  onTabClose: (id: number) => void;
}

export default function TabBar({
  tabs,
  activeTabId,
  onTabClick,
  onTabClose,
}: TabBarProps) {
  if (tabs.length === 0) {
    return null;
  }

  return (
    <div className="tab-bar">
      {tabs.map((tab) => (
        <div
          key={tab.id}
          className={`tab ${activeTabId === tab.id ? "active" : ""}`}
          onClick={() => onTabClick(tab.id)}
          style={tab.color ? { borderLeftColor: tab.color } : undefined}
        >
          <span className="tab-name">{tab.name}</span>
          <button
            className="tab-close"
            onClick={(e) => {
              e.stopPropagation();
              onTabClose(tab.id);
            }}
            title="Close tab"
          >
            &times;
          </button>
        </div>
      ))}
    </div>
  );
}
